import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "none",
  strokeLinecap: "square",
  transform: "translate(10.000000, 10.000000) rotate(45.000000) translate(-10.000000, -10.000000) translate(5.000000, 5.000000)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M0,5 L10,5"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M5,10 L5,1.77635684e-15"
}));

var SvgPermissionSmallCross = function SvgPermissionSmallCross(props) {
  return _ref;
};

export default SvgPermissionSmallCross;